/**
 * Chuẩn hoá giá trị số (%, phí) trước khi gửi lên API.
 *
 * Các field như `maintenancePercentage`, `vatTax`, `landUseFee` map sang
 * `decimal` / `double` KHÔNG nullable ở backend (ContractCreateDto). Khi user
 * xoá trắng ô nhập, AntD InputNumber trả về `null` → JSON `null` → backend ném
 * `AbpValidationException: Error converting value {null} to type 'System.Decimal'`.
 *
 * Khác `roundContractPriceUp`: KHÔNG làm tròn về số nguyên (giữ 2.5%, 0.5%…).
 */
export function toNumberOrZero(
  value: number | string | undefined | null
): number {
  if (value === null || value === undefined || value === "") {
    return 0
  }
  const n = Number(value)
  return Number.isFinite(n) ? n : 0
}
